import React, { memo, useMemo } from 'react';
import './index.less';
import LoginBackground from './Background';
import Helmet from 'react-helmet';
import { getPageTitle, loginRouteList } from '@/router/utils';
import { IRoute } from '@/router/config';
import { Route, useLocation } from 'react-router-dom';
import HeadBtn from '../components/headBtn';
import { connect } from 'react-redux';
import { IStoreState } from '@/store/types';
import { personalProps } from '@/components/Login/typings';
// import { getLocalStorage } from '@/utils/localStorage';
// import { LOGIN_HISTORY_KEY } from '../types';
// import utils from '../utils';

function createRenderRoute(route: IRoute): React.ReactNode {
  const title = getPageTitle(loginRouteList);
  const { component: Component } = route;
  return (
    <Route
      key={route.path}
      exact={route.path !== '*'}
      path={route.path}
      render={props => (
        <>
          <Helmet>
            <title>{title}</title>
            <meta name="description" content={title}></meta>
          </Helmet>
          <Component {...props}></Component>
        </>
      )}
    ></Route>
  );
}

function createRenderRouteList(paths?: string[]): React.ReactNode[] {
  const routerList: React.ReactNode[] = [];
  loginRouteList.forEach((child: IRoute) => {
    if (paths && !paths.includes(child.path)) return;
    if (!paths && LOGIN_CREDENTIAL_PATHS.includes(child.path)) return;
    routerList.push(createRenderRoute(child));
  });
  return routerList;
}

const LOGIN_CREDENTIAL_PATHS = ['/login/account', '/login/phone'];

function LoginLayout(props: { userinfo: personalProps }) {
  const { pathname } = useLocation();
  const credentialRoutes = useMemo(() => createRenderRouteList(LOGIN_CREDENTIAL_PATHS), []);
  const otherRoutes = useMemo(() => createRenderRouteList(), []);
  const showCredentialShell = LOGIN_CREDENTIAL_PATHS.includes(pathname);
  return (
    <LoginBackground>
      {showCredentialShell ? (
        <div className="main_position_box">
          <HeadBtn headBtnType={1} />
          {credentialRoutes}
        </div>
      ) : null}
      {otherRoutes}
    </LoginBackground>
  );
}

export default connect(
  ({ user: { userinfo } }: IStoreState) => ({
    userinfo
  }),
  {}
)(memo(LoginLayout));
